import script from "./InputInterval.vue?vue&type=script&lang=ts&setup=true"
export * from "./InputInterval.vue?vue&type=script&lang=ts&setup=true"

import "./InputInterval.vue?vue&type=style&index=0&id=25484ed3&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25484ed3"]])

export default __exports__